import React, { useState, useEffect } from "react";
import {
  Typography,
  Modal,
  Box,
  ImageListItem,
  Divider,
  Button,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import MenuItem from "@mui/material/MenuItem";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Close from "../../../assets/icons/Close.svg";
import Autocomplete from "@mui/material/Autocomplete";
import countries from "../../../utils/CountryCodeData";
import GreyDownArrow from "../../../assets/icons/GreyDownArrow.svg";
import {
  addUserMasterList,
  setIsOpenModelAddUserMaster,
} from "../../../redux/actions/mastersAction";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 700,
  bgcolor: "background.paper",
  border: "1px solid #FFFFFF",
  boxShadow: 24,
  padding: "20px 0px 20px 0px",
  borderRadius: "12px",
  outline: "none",
};

export const passwordGenerator = () => {
  return stringGen(4) + "@" + numberGen(4);
};
export const stringGen = (len) => {
  var text = "";
  var charset = "abcdefghijklmnopqrstuvwxyz";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
};
export const numberGen = (len) => {
  var text = "";
  var charset = "0123456789";
  for (var i = 0; i < len; i++)
    text += charset.charAt(Math.floor(Math.random() * charset.length));
  return text;
};

const AddManagementMasterModel = (Props) => {
  const dispatch = useDispatch();
  const isSaveButtonLoading = useSelector(
    (state) => state?.user?.isSaveButtonLoading
  );
  const defaultCountry = countries.find((country) => country.code === "AE");
  const ManagementID = localStorage.getItem("ManagementID");
  const CompanyID = localStorage.getItem("companyID");
  const [CountryCodeValue, setCountryCodeValue] = useState(
    defaultCountry?.phone
  );
  const AddManagementModel = useSelector(
    (state) => state?.masters?.models?.AddUserMasterModel
  );

  const handleChangeCountryCodeValue = (newValue) => {
    setCountryCodeValue(newValue?.phone);
  };

  const [ManagementData, setManagementData] = useState({
    FirstName: "",
    LastName: "",
    Email: "",
    CompanyPhoneNo: "",
  });

  const handleChangeManagementData = (e) => {
    const { name, value } = e.target;
    setManagementData({ ...ManagementData, [name]: value });
  };

  const handleSaveManagement = async (event) => {
    event.preventDefault();
    if (
      ManagementData?.FirstName !== "" &&
      ManagementData?.LastName !== "" &&
      ManagementData?.Email !== "" &&
      CountryCodeValue !== undefined &&
      ManagementData?.CompanyPhoneNo !== ""
    ) {
      const emailPattern =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (emailPattern.test(ManagementData?.Email)) {
        dispatch(
          addUserMasterList({
            first_name: ManagementData?.FirstName,
            last_name: ManagementData?.LastName,
            email: ManagementData?.Email,
            phone: "+" + CountryCodeValue + ManagementData?.CompanyPhoneNo,
            username:
              ManagementData?.FirstName?.toLowerCase() +
              "." +
              ManagementData?.LastName?.toLowerCase(),
            company_id: CompanyID,
            role_id: ManagementID,
            is_super_admin: "false",
            password: passwordGenerator(),
          })
        );
      } else {
        toast.error("Please enter valid Email ID");
      }
    } else {
      toast.error("Please enter all details to proceed");
    }
  };

  useEffect(() => {
    if (!AddManagementModel) {
      setManagementData({
        FirstName: "",
        LastName: "",
        Email: "",
        CompanyPhoneNo: "",
      });
    }
  }, [AddManagementModel]);

  countries.sort((a, b) => a.label.localeCompare(b.label));

  return (
    <Modal
      open={AddManagementModel}
      onClose={() => {
        dispatch(setIsOpenModelAddUserMaster(false));
        // setManagementData({
        //   FirstName: "",
        //   LastName: "",
        //   Email: "",
        //   CompanyPhoneNo: "",
        // });
      }}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <Box
          sx={{
            display: "flex",
            marginBottom: "20px",
          }}
        >
          <Box sx={{ width: "90%" }}>
            <Typography
              align="center"
              sx={{
                color: "#212121",
                fontSize: "22px",
                fontWeight: 500,
                position: "relative",
                left: "35px",
              }}
            >
              Add New Management User
            </Typography>
          </Box>
          <Box
            sx={{
              width: "10%",
              display: "flex",
              justifyContent: "end",
              alignItems: "center",
              mr: 3,
            }}
          >
            <ImageListItem
              sx={{ cursor: "pointer", width: "15px" }}
              onClick={() => {
                dispatch(setIsOpenModelAddUserMaster(false));
                // setManagementData({
                //   FirstName: "",
                //   LastName: "",
                //   Email: "",
                //   CompanyPhoneNo: "",
                // });
              }}
            >
              <img src={Close} alt="" />
            </ImageListItem>
          </Box>
        </Box>
        <Divider />
        <Box sx={{ padding: "20px" }}>
          <Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="First Name"
                name="FirstName"
                value={ManagementData?.FirstName}
                onChange={handleChangeManagementData}
                sx={{
                  width: "100%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Last Name"
                name="LastName"
                value={ManagementData?.LastName}
                onChange={handleChangeManagementData}
                sx={{
                  borderRadius: "10px",
                  width: "100%",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Email"
                name="Email"
                value={ManagementData?.Email}
                onChange={handleChangeManagementData}
                sx={{
                  width: "100%",
                  borderRadius: "50px",
                  backgroundColor: "#F3F6F9",
                  borderRadius: "10px",
                  border: "none",
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                    borderRadius: "10px",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                gap: "10px",
                mb: "20px",
              }}
            >
              <Autocomplete
                id="country-select-demo"
                sx={{ width: 300 }}
                options={countries}
                defaultValue={defaultCountry}
                onChange={(event, newValue) =>
                  handleChangeCountryCodeValue(newValue)
                }
                autoHighlight
                getOptionLabel={(option) => "+" + option.phone}
                filterOptions={(options, state) => {
                  // Filter based on option.label
                  return options.filter((option) =>
                    option.label
                      .toLowerCase()
                      .includes(state.inputValue.toLowerCase())
                  );
                }}
                renderOption={(props, option) => (
                  <Box
                    component="li"
                    sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                    {...props}
                    key={option.label}
                  >
                    <img
                      loading="lazy"
                      width="20"
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      alt=""
                    />
                    {option.label}
                    {/* ({option.code}) +{option.phone} */}
                  </Box>
                )}
                renderInput={(params) => (
                  <TextField
                    sx={{
                      width: "100%",
                      borderRadius: "10px",
                      backgroundColor: "#F3F6F9",
                      borderRadius: "10px",
                      border: "none",
                      "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                        border: "0px solid #F3F6F9",
                        borderRadius: "10px",
                      },
                      "& .MuiOutlinedInput-notchedOutline": { border: "none" },
                      "& .MuiAutocomplete-clearIndicator": {
                        display: "none",
                      },
                    }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    placeholder="Select Country"
                    {...params}
                    inputProps={{
                      ...params.inputProps,
                      autoComplete: "new-password",
                    }}
                  />
                )}
              />

              <TextField
                id="outlined-basic"
                variant="outlined"
                placeholder="Company Phone No"
                type="number"
                name="CompanyPhoneNo"
                value={ManagementData?.CompanyPhoneNo}
                onChange={handleChangeManagementData}
                sx={{
                  width: "70%",
                  borderRadius: "10px",
                  backgroundColor: "#F3F6F9",
                  border: "none",
                  "& .MuiInputBase-input": {
                    "&::-webkit-inner-spin-button, &::-webkit-outer-spin-button":
                      {
                        "-webkit-appearance": "none",
                        margin: 0,
                      },
                    "-moz-appearance": "textfield",
                  },
                  "& .css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
                    border: "0px solid #F3F6F9",
                  },
                  "& .MuiOutlinedInput-notchedOutline": {
                    border: "none",
                  },
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </Box>
          </Box>
          <Box
            sx={{
              marginTop: "40px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "15px",
            }}
          >
            <Box>
              <Button
                // variant="contained"
                sx={{
                  fontSize: "15px",
                  border: "1px solid #26875C",
                  fontWeight: 600,
                  width: "8rem",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#26875C",
                }}
                onClick={() => {
                  dispatch(setIsOpenModelAddUserMaster(false));
                  // setManagementData({
                  //   FirstName: "",
                  //   LastName: "",
                  //   Email: "",
                  //   CompanyPhoneNo: "",
                  // });
                }}
              >
                Cancel
              </Button>
            </Box>
            <Box>
              <LoadingButton
                onClick={handleSaveManagement}
                sx={{
                  fontSize: "15px",
                  fontWeight: 600,
                  width: "8rem",
                  border: "1px solid #26875C",
                  backgroundColor: "#26875C",
                  padding: "10px 5px 10px 5px",
                  borderRadius: "10px",
                  textTransform: "capitalize",
                  color: "#FFFFFF",
                  ":hover": {
                    backgroundColor: "#26875C",
                  },
                }}
                loading={isSaveButtonLoading}
              >
                Save
              </LoadingButton>
            </Box>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default AddManagementMasterModel;
